export enum AUTHENTICATION_CODE {
  CLIENT_PROFILE_ACTIVE = 'CLIENT_PROFILE_ACTIVE',
  CLIENT_PROFILE_NOT_FOUND = 'CLIENT_PROFILE_NOT_FOUND',
  CLIENT_PROFILE_PENDING = 'CLIENT_PROFILE_PENDING',
  CLIENT_PROFILE_BLOCKED = 'CLIENT_PROFILE_BLOCKED',
  CLIENT_TO_CONFIRM_DOES_NOT_EXIST = 'CLIENT_TO_CONFIRM_DOES_NOT_EXIST',
  OTP_RESEND_BLOCKED = 'OTP_RESEND_BLOCKED',
  OTP_DELIVERY_FAILURE = 'OTP_DELIVERY_FAILURE',
  USER_INVITED = 'USER_INVITED'
}
